<div class="main-div">

    <div></div>

    <div class="main-header"> Add/edit a <br /> participant</div>

    <div class="break"></div>
    
    <div class="main-text"> Type in the participant's <br />QR number and then fill in the details</div>
    <div class="break"></div>
    <mat-card class="card">
    
        <mat-card-content>
            <div class="card-header">Type participant QR number</div>

            <form
            [formGroup]="qrForm"
            (ngSubmit)="onSubmit()"
            class="example-form"
            autocomplete="off"
          >
          <div class="spacer"></div>
          <mat-form-field class="example-full-width">
            <mat-label>Participant's QR number</mat-label>
            <input
              matInput
              formControlName="qrnumber"
              placeholder="Type the QR number"
              aria-autocomplete="list"
            />
            <mat-hint align="start"><strong>Type the participant's
              QR number - Ex. A100</strong> </mat-hint>
  
            <mat-error>
              The QR number is <strong>required</strong>
            </mat-error>



          </mat-form-field>

          <div class="spacer"></div><button mat-raised-button color="primary" type="submit" class="black-button">
            Submit
          </button>

          </form>
          <div class="spacer"></div>
          <div class="or-text">OR</div>
          <div class="spacer"></div>
          <div class="main-div">
          <mat-card class="card2" (click)="gotoQRcode()">
  <div class="icon-container">
            <mat-icon aria-hidden="false" aria-label="Scan the QR code" class="mat-icon-style">qr_code_2</mat-icon>
          </div>
            <div class="break"></div>
          QR Code
          </mat-card>
        </div>




        </mat-card-content></mat-card>
        <div class="break"></div>
        <div class="spacer"></div>
</div>
<app-mat-spinner-overlay overlay="true" *ngIf="loading">
</app-mat-spinner-overlay>
